// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ProductsModal_modalBody__3glZN","modalHead":"ProductsModal_modalHead__fkZQp"};